module.exports = __webpack_public_path__ + "files/android_certified_application_developer.6e3cf65e.pdf";